import type { SaunaSessionHistoryResponse } from '@jums-dashboard/shared';
import { useQuery } from '@tanstack/react-query';

import { useAuth } from '@/app/auth';
import { getSaunaSessionHistory } from '../services/saunaService';

const STALE_TIME_MS = 5 * 60_000;

export const saunaSessionHistoryQueryKey = (homeId: string | undefined) =>
  ['homeAutomation', 'saunaSessionHistory', homeId ?? null] as const;

/** Session history (90-day window) + setup notes. Sessions change slowly, so no polling. */
export default function useSaunaSessionHistory(homeId: string | undefined, enabled: boolean) {
  const { status } = useAuth();
  const gate = status === 'authorized' && !!homeId && enabled;

  return useQuery<SaunaSessionHistoryResponse>({
    queryKey: saunaSessionHistoryQueryKey(homeId),
    queryFn: () => getSaunaSessionHistory(homeId!),
    enabled: gate,
    staleTime: STALE_TIME_MS,
  });
}
